import { ustIdPruefen } from "@mrmachine/fach";

/**
 * **Die USt-IdNr. wird geprüft, bevor sie den Rechner verlässt** (08.10.2026).
 *
 * Dieselbe Regel wie in der API (`ustIdOptional`), aus `@mrmachine/fach`:
 * Die Maske sagt es am Feld, die API weist ab, falls doch etwas durchkommt.
 * Leer ist kein Fehler — ob das Feld Pflicht ist, entscheidet die
 * Pflichtfeldregel.
 *
 * Gibt den i18n-Pfad und die Werte für den Satz zurück, oder `null`.
 */
export function ustIdHinweis(
  wert: string | null | undefined,
): { pfad: "fehler.eingabeUstIdLand" | "fehler.eingabeUstIdFormat"; werte: { ust_id: string; land: string } } | null {
  const roh = (wert ?? "").trim();
  if (!roh) return null;
  const geprueft = ustIdPruefen(roh);
  if (geprueft.ok) return null;
  return {
    pfad: geprueft.grund === "format" ? "fehler.eingabeUstIdFormat" : "fehler.eingabeUstIdLand",
    werte: { ust_id: roh, land: geprueft.land ?? "" },
  };
}
